import React from 'react';
import { Link} from 'react-router-dom';

const Navbar: React.FC = () => {

  return (
    <nav className="fixed top-0 w-full z-50 bg-bg-main pt-8 pb-8">
      <div className="flex justify-center items-center w-full">
        <div className="flex justify-between items-center" style={{ width: '450px' }}>
          <Link
            to="/"
            className="text-lg text-text-white drop-shadow-glow-sm hover:drop-shadow-glow transition-colors">
            arid.place
          </Link>
          
          <Link
            to="/cv"
            className="text-lg text-text-white drop-shadow-glow-sm hover:drop-shadow-glow transition-colors">
            cv
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
